import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractTranslatedApiErrorMessage } from '../../shared/utils/translate-api-error.util';
import { Segment } from '../types/segment.type';
import { ADMIN_SEGMENTS_API_PATHS } from '../constants/segments-api-paths.constants';

type UpdateSegmentParams = {
  segmentId: string;
  segmentData: Partial<Segment>;
};

type UseUpdateSegmentResult = {
  updateSegment: (params: UpdateSegmentParams) => Promise<Segment | null>;
  isSubmitting: boolean;
};

export function useUpdateSegment(): UseUpdateSegmentResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const updateSegment = async ({ segmentId, segmentData }: UpdateSegmentParams): Promise<Segment | null> => {
    setIsSubmitting(true);

    try {
      const updatedSegment = await HttpClient.patch<Segment, Partial<Segment>>(
        ADMIN_SEGMENTS_API_PATHS.UPDATE_SEGMENT(segmentId),
        segmentData
      );

      enqueueSnackbar('Le segment a été mis à jour avec succès', { variant: 'success' });
      return updatedSegment;
    } catch (error) {
      enqueueSnackbar(
        extractTranslatedApiErrorMessage(error, 'Une erreur est survenue lors de la mise à jour du segment'),
        { variant: 'error' }
      );
      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { updateSegment, isSubmitting };
}
